import styles from './Header.module.scss';
import sharedStyles from '@/modules/opinions/Shared.module.scss';

import { Avatar } from '@/components';
import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import { useNavigation } from '@/hooks/useNavigation';
import {
  type OpinionPollVoted,
  calcFont,
  useOpinionContext,
} from '@/modules/opinions';
import { PAGE } from '@/modules/page/routes';
import cn from 'classnames';

export const Header = ({ opinion }: { opinion: OpinionPollVoted }) => {
  const { isVoted, sliderValue, answerItemId } = useOpinionContext();
  const { goTo, currentPage } = useNavigation();
  const { triggerHapticFeedback } = useHapticFeedback();

  const onClick = () => {
    if (currentPage === PAGE.PROFILE_ID_OPINION_ID) return;
    triggerHapticFeedback('medium');
    goTo(PAGE.PROFILE_ID, { id: opinion.author.id });
  };

  return (
    <div className={cn(styles.header, !answerItemId && styles.pb)}>
      <p
        className={styles.question}
        style={{
          fontSize: calcFont(opinion.title, 2),
        }}
      >
        {opinion.title}
      </p>
      <div className={styles.info}>
        {!isVoted && answerItemId ? (
          <span
            className={cn(styles.percentage, isVoted && sharedStyles.opacity0)}
          >
            {sliderValue}%
          </span>
        ) : (
          <span
            className={cn(styles.user, isVoted && sharedStyles.opacity1)}
            onClick={onClick}
          >
            <Avatar _id={opinion.author.id} className={styles.avatar} />
            <span className={styles.username}>{opinion.author.username}</span>
          </span>
        )}
      </div>
    </div>
  );
};
